import { Clickable, P } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import { THIRD_PARTY } from '@ahmdigital/urls/lib/urls';
import { useCallback } from 'react';
import { useFormikContext } from 'formik';

import { AnnualIncomeContainer, ContentWrapper } from './styles';
import { HealthFormValues } from '../../../../types';
import { INCOME_TIER_NONE } from '../../../../../../components/pricing-drawer/constants';
import { ModalComponentProps } from '../../../../../../components/embedded-widget/types';
import { StyledHeading, StyledJourneyButton } from '../styles';
import addNoRebateIncomeTier from '../../../../../../utils/add-no-rebate-income-tier';
import constants from '../../../../../../ahm-constants';
import getIncomeTierOptions, { IncomeType } from '../../../../../../utils/get-income-tier-options';

const AnnualIncomeSelector = ({ setIsModalOpen }: ModalComponentProps) => {
  const { values, setFieldValue } = useFormikContext<HealthFormValues>();

  const { incomeType } = values;

  const incomeTierOptions = getIncomeTierOptions({ incomeType: incomeType as IncomeType });
  const allOptions = addNoRebateIncomeTier(incomeTierOptions);

  const heading =
    incomeType === constants.INCOME_TYPE.SINGLE
      ? 'Please select your annual income.'
      : 'Please select your combined annual income.';

  const setAnnualIncomeHandler = useCallback(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'income' implicitly has an 'any' type.
    (income) => {
      setFieldValue('incomeTier', income);
      setFieldValue('rebate', income !== INCOME_TIER_NONE);
      setIsModalOpen(false);
    },
    [setFieldValue, setIsModalOpen],
  );

  return (
    <ContentWrapper>
      <StyledHeading looksLike="h5">{heading}</StyledHeading>
      <P>
        This is your income for{' '}
        <Clickable to={THIRD_PARTY.ATO_MEDICARE_LEVY_SURCHARGE}>Medicare Levy Surcharge</Clickable> purposes, which is
        different to taxable income.
      </P>
      <AnnualIncomeContainer>
        {map(
          ({ text, value }) => (
            <StyledJourneyButton key={value} onClick={() => setAnnualIncomeHandler(value)} analytics={{ label: value }}>
              {text}
            </StyledJourneyButton>
          ),
          allOptions,
        )}
      </AnnualIncomeContainer>
    </ContentWrapper>
  );
};

export default AnnualIncomeSelector;
